<template>
  <button 
    class="btn btn-success click-to-call-btn" 
    :class="{ 'disabled': isCalling }"
    @click.prevent="makeCall"
    :title="`Llamar al ${phoneNumber}`"
  >
    <i v-if="!isCalling" class="ri-phone-fill"></i>
    <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </button>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: 'ClickToCallButton',
  props: {
    phoneNumber: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isCalling: false
    }
  },
  methods: {
    async makeCall() {
      if (this.isCalling || !this.phoneNumber) return;
      
      this.isCalling = true;
      try {
        const response = await axios.post('/api/callup/make-call', {
          phone_number: this.phoneNumber
        });
        
        if (response.data.success) {
          Swal.fire({
            title: 'Llamada Iniciada',
            text: 'Revisa tu Softphone de CallUp.',
            icon: 'success',
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          });
        }
      } catch (error) {
        let errorMsg = 'Error al intentar iniciar la llamada.';
        if (error.response && error.response.data && error.response.data.error) {
          errorMsg = error.response.data.error;
        }
        
        Swal.fire({
          title: 'Error',
          text: errorMsg,
          icon: 'error',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 5000
        });
      } finally {
        this.isCalling = false;
      }
    }
  }
}
</script>

<style scoped>
.click-to-call-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
